/* Ascending Priestess homepage sections — motion + interactions.
   Re-runs per section so the Theme Editor (shopify:section:load) stays in sync. */
(() => {
  if (window.__apHome) return;
  window.__apHome = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('ap-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  const splitWords = el => {
    if (el.dataset.apSplit) return;
    el.dataset.apSplit = '1';
    const walk = node => {
      [...node.childNodes].forEach(child => {
        if (child.nodeType === 3) {
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'ap-w';
            const i = document.createElement('span'); i.textContent = part;
            w.appendChild(i); frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'SPAN') {
          walk(child);
        }
      });
    };
    walk(el);
    el.querySelectorAll('.ap-w>span').forEach((s, i) => { s.style.transitionDelay = (i * 45) + 'ms'; });
  };

  const init = root => {
    root.querySelectorAll('.ap-split').forEach(splitWords);
    root.querySelectorAll('.ap-reveal,.ap-split,.ap-mask').forEach(el => io.observe(el));
    // hero content is already in view on load
    requestAnimationFrame(() => root.querySelectorAll('.ap-hero .ap-reveal,.ap-hero .ap-split').forEach(el => el.classList.add('ap-in')));
    root.querySelectorAll('.ap-door-grid,.ap-offers,.ap-rituals').forEach(grid => {
      [...grid.children].forEach((c, i) => { c.style.transitionDelay = (i * 90) + 'ms'; });
    });

    /* pillars: scroll-scrubbed word fill */
    root.querySelectorAll('.ap-scrub').forEach(scrub => {
      const words = [...scrub.querySelectorAll('.ap-scrub__w')];
      const update = () => {
        const r = scrub.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (vh * 0.5)));
        const lit = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle('ap-lit', reduce ? true : i < lit));
      };
      update();
      // Atelier/Horizon scroll inside .page-wrapper, so listen in the capture phase on document
      document.addEventListener('scroll', update, { passive: true, capture: true });
      window.addEventListener('resize', update);
      setTimeout(update, 600);
    });

    /* The Altar: tab / world swap */
    root.querySelectorAll('.ap-altar').forEach(altar => {
      const tabs = [...altar.querySelectorAll('.ap-tab')];
      const worlds = [...altar.querySelectorAll('.ap-world')];
      if (!tabs.length) return;
      const go = key => {
        altar.dataset.world = key;
        tabs.forEach(t => { const on = t.dataset.world === key; t.classList.toggle('ap-is-active', on); t.setAttribute('aria-selected', on); });
        worlds.forEach(w => { const on = w.dataset.world === key; w.classList.toggle('ap-is-active', on); w.hidden = !on; });
      };
      tabs.forEach(t => t.addEventListener('click', () => go(t.dataset.world)));
      altar.querySelector('.ap-tabs').addEventListener('keydown', e => {
        const i = tabs.findIndex(t => t.classList.contains('ap-is-active'));
        if (e.key === 'ArrowRight') { const n = tabs[(i + 1) % tabs.length]; go(n.dataset.world); n.focus(); }
        if (e.key === 'ArrowLeft') { const n = tabs[(i - 1 + tabs.length) % tabs.length]; go(n.dataset.world); n.focus(); }
      });
    });

    /* sticky testimonial stack offsets */
    root.querySelectorAll('.ap-card-q').forEach((c, i) => c.style.setProperty('--i', i));
  };

  const run = () => document.querySelectorAll('.ap-s').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  /* Theme editor: re-init a section after it re-renders; open the tab for a selected Altar block */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const tab = e.target.closest('.ap-altar') && e.target.dataset.world;
    if (tab) e.target.closest('.ap-altar').querySelector('.ap-tab[data-world="' + tab + '"]')?.click();
  });
})();
